import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Modal = (props) => {
  return (
    <div className="modal">
      <div className="modal-content" style={{ height: props.modalHeight || null }}>
        <span className="close" onClick={props.onClose}>
          &times;
        </span>
        {props.children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  modalHeight: PropTypes.number,
  onClose: PropTypes.func,
  children: PropTypes.number,
};

export default memo(Modal);
